import { render, staticRenderFns } from "./AffiliateLink.vue?vue&type=template&id=28dd2ea2&scoped=true&"
import script from "./AffiliateLink.vue?vue&type=script&lang=js&"
export * from "./AffiliateLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd2ea2",
  null
  
)

export default component.exports